import React from 'react';
import SEOHelmet from '../SEOHelmet';

const BestPsychiatristNizzamundin: React.FC = () => {
  return (
    <div className="bg-white text-pink-700 min-h-screen p-8">
      <SEOHelmet
       
      />
      <h1 className="text-4xl font-bold mb-6">Dr. Bushra Zahoor - Psychiatrist Serving Nizamuddin, Delhi</h1>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Comprehensive Mental Health Care in Nizamuddin</h2>
        <p className="mb-4">Dr. Bushra Zahoor, MBBS (Gold Medalist), MD, DNB (Psychiatry), offers clinical care for a wide range of mental health conditions at Asiaz Hospital, serving patients in Nizamuddin and surrounding areas of Delhi.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Comprehensive Psychiatric Services:</h3>
        <ul className="list-disc list-inside">
          <li>Depression and Anxiety Treatment</li>
          <li>Bipolar Disorder Management</li>
          <li>Relationship and Family Counseling</li>
          <li>Stress and Anger Management</li>
          <li>Psychosis and Complex Mental Disorders</li>
          <li>Addiction Therapy (including Technology Addiction)</li>
          <li>Migraine and Psychosomatic Conditions</li>
        </ul>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Why Choose Dr. Bushra Zahoor?</h3>
        <ul className="list-disc list-inside">
          <li>MBBS (Gold Medalist)</li>
          <li>MD in Psychiatry</li>
          <li>DNB in Psychiatry</li>
          <li>Assistant Professor, Department of Psychiatry</li>
          <li>Personalized treatment plans tailored to individual needs</li>
          <li>State-of-the-art facilities at Asiaz Hospital</li>
          <li>Holistic approach to mental health and well-being</li>
          <li>Expertise in addressing urban lifestyle-related mental health issues</li>
        </ul>
      </section>
      <section>
        <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
        <p>Phone: +91-9310330922</p>
        <p>Email: bushra.zhro7@gmail.com</p>
        <p>Address: Plot No. 140, Sector 15 Part 2, Near Mother Dairy, Gurugram, Haryana - 122001</p>
        <p className="mt-4">Schedule a consultation with Dr. Bushra Zahoor, Psychiatrist serving Nizamuddin, to discuss your mental health and treatment options.</p>
      </section>
    </div>
  );
};

export default BestPsychiatristNizzamundin;